import * as React from "react";
import { useEffect, useRef, useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { CircularProgress, FormHelperText, Grid, MenuItem, Popover, Tab, Tabs } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
    confirmProtocolWorkflow,
    rejectProtocolConfirmationWorkflow,
    $authHost, protocolSignerCRUD, resultCRUD, referralCRUD, anObjectReferralCRUD
} from '../../../http';
import { accreditationCRUD, accreditationIndicatorCRUD, actCRUD, entityCRUD, protocolCRUD, protocolsCRUD } from '../../../http/CRUD'
import { asJSONSafe, fetchAsBase64, normalizeAccreditationRow, resolveProtocolLogoName } from "../../../functions";
import { withProtocolParentLinks } from "../../../functions/viewDataMap";
import { fetchKsekDocumentPurpose } from "../../../functions/ksekDocumentPurpose";

import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import Select from '@mui/material/Select'
import FormGroup from '@mui/material/FormGroup'
import FormControlLabel from '@mui/material/FormControlLabel'
import Checkbox from '@mui/material/Checkbox'
import Stack from '@mui/material/Stack'
import TextField from '@mui/material/TextField'

import AdapterDateFns from '@mui/lab/AdapterDateFns'
import LocalizationProvider from '@mui/lab/LocalizationProvider'
import ruLocale from 'date-fns/locale/ru'
import DateTimePicker from '@mui/lab/DateTimePicker'
import logos, { filialsMapping } from '../PDFGenerator/logos/index.js'
import HtmlGenerator from '../HtmlGenerator/index'
import { js2xml } from 'xml-js';
import { parseJsonSafe, toUIJson } from "../../../functions";
import { useNCALayerClient } from "../../../functions/sign/SignHooks";
import LoadingButton from "@mui/lab/LoadingButton";
import useLoader from "../../../hooks/useLoader";
import useAlert from "../../../hooks/useAlert";
import { generateLink, renderPageNumeration, renderPageNumerationAndWatermark } from "../../../functions/renderProtocol";
import { formatDate, MOMENT_FORMAT_DATE_DMYHM_DOTS } from "../../../functions/formatters";
import { distinct, selectMany } from "../../../functions/linqSimulation";
import useRoles from "../../../hooks/useRoles";
import logoWatermark from '../PDFGenerator/watermark/logo_watermark.png';
import { ClientPdf } from "../_sections/ClientPdf.jsx";
import { equals, page, where } from "../../../functions/resourceLinq1.js";
import useResourceLinq from "../../../data/useResourceLinq.js";
import { ProtocolPdf } from "../_sections/ProtocolPdf.jsx";
import { TabPanel } from "@mui/lab";
import { InfoCircleOutlined } from "@ant-design/icons";
import { protocolStateIds } from "../../../models/protocolStateIds.js";
import {
    COMPLIANCE_STATUS,
    COMPLIANCE_STATUS_OPTIONS,
    CONFIRMATION_STATUS,
    getComplianceStatusLabel,
    getConfirmationStatusLabel,
    normalizeComplianceStatus,
    normalizeConfirmationStatus,
    shouldShowProtocolCompliance,
} from "../../../models/protocolCompliance.js";
import {
    canEditProtocolType,
    getProtocolTypeHelperText,
    getProtocolTypeLabel,
    isPaidProtocolOrderType,
    normalizeProtocolTypeId,
    resolveProtocolOrderType,
    resolveProtocolTypeId,
    shouldShowProtocolType,
} from "../../../models/protocolType.js";
import { orderTypeIds } from "../../../models/orderTypeIds";
import { getProtocolTypes } from "../../../redux/actions/protocolTypeActions";
import { confirmDialog } from "../../../components/Dialog/DialogDelete";
import optionalLogo from '../PDFGenerator/logos/common/ilac_mra.svg';
import { svgToPngFromDpi } from "../../../functions/svgToPng.js";
import {
    getOrCreateIdbOnly,
    PROTOCOL_ACCREDITATIONS_IDB_CACHE_KEY,
    PROTOCOL_ACCREDITATIONS_IDB_TTL_MIN,
} from "../../../services/cacheService.js";
import { getProtocolFormByKey } from "../../../redux/actions/protocolFormActions.js";
import forms from "../ProtocolForms/forms/index.js";
import ProtocolPdfModel from "../../../models/protocolPdfModel.js";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { injectVfsTimesNewRoman } from "../../../functions/pdfMake/timesNewRomanFonts";
import {
    accreditationCodesMatch,
    buildAccreditationInfoFromIndicator,
    findAccreditationIndicatorByName,
} from "../../../functions/accreditationProtocolFill";

pdfMake.vfs = pdfFonts.pdfMake.vfs;
injectVfsTimesNewRoman(pdfMake.vfs);

window.Buffer = window.Buffer || require("buffer").Buffer;
const { TabPane } = Tabs;

const style = {
    position: 'absolute',
    top: '10%',
    bottom: '20%',
    left: '20%',
    right: '20%',
    bgcolor: 'background.paper',
    boxShadow: 24,
    overflow: 'auto',
    height: '85%',
    display: 'block',
    p: 4,
};

export const fetchPdf = () => {
    // var data = { id: 1 };
    // let urlFull = `${getLocationOrigin(20081)}/${'api/v1/protocol/pdf'}`;
    // urlFull = 'http://185.237.186.69:20081/api/v1/protocol/pdf';
    // return postForDownloadFile(data, urlFull);
};

export default function ProtocolDetails({
    action,
    reload,
    title,
    open,
    setOpen,
    onSubmit,
    query,
    protocol,
    loading,
    allowConfirmation = false,
    ...props
}) {
    const [id, setId] = useState(null);
    const [number, setNumber] = useState('');
    const [createdAt, setCreatedAt] = useState('');
    const [signedDate, setSignedDate] = useState('');
    const [formId, setFormId] = useState('');
    const [referralId, setReferralId] = useState('');
    const [resultId, setResultId] = useState('');
    const [filialId, setFilialId] = useState('');
    const [filialDivisionId, setFilialDivisionId] = useState('');
    const [employee, setEmployee] = useState(null);
    const [filialDivision, setFilialDivision] = useState(null);
    const [availableLogos, setAvailableLogos] = useState(null);
    const [logos, setLogos] = useState(null);
    const [logoSearch, setLogoSearch] = useState('');
    const [departmentId, setDepartmentId] = useState('');
    const [divisionId, setDivisionId] = useState('');
    const [responsibleId, setResponsibleId] = useState('');
    const [performerId, setPerformerId] = useState('');
    const [data, setData] = useState('');
    const [addOptionalLogo, setAddOptionalLogo] = React.useState(false)
    const [signed, setSigned] = React.useState(false)
    const [logo, setLogo] = React.useState('')
    const [protocolIssueDate, setProtocolIssueDate] = React.useState(null)
    const [employeeFilial, setEmployeeFilial] = React.useState({})
    const [signers, setSigners] = React.useState([])
    const [result, setResult] = React.useState(null);
    const [userCanSignProtocol, setUserCanSignProtocol] = React.useState(false);
    const [signersIds, setSignersIds] = React.useState([]);

    const [openChild, setOpenChild] = React.useState(false)
    const [comment, setComment] = React.useState('')
    const [complianceStatus, setComplianceStatus] = React.useState(null);
    const [confirmationStatus, setConfirmationStatus] = React.useState(null);
    const [confirmationComment, setConfirmationComment] = React.useState('');
    /** Только госзаказ + цель «Контрольный закуп…» */
    const [showComplianceFields, setShowComplianceFields] = React.useState(false);
    /** Тип протокола — только платные (OrderType = Payed) */
    const [typeId, setTypeId] = React.useState(null);
    const [protocolTypes, setProtocolTypes] = React.useState([]);
    const [orderType, setOrderType] = React.useState(null);
    const [showProtocolTypeFields, setShowProtocolTypeFields] = React.useState(false);

    const [client, ready] = useNCALayerClient();
    const [ecpProtocolXml, setEcpProtocolXml] = useState('');
    const [ecpMessage, setEcpMessage] = useState(null);
    const [ecpProtocolSignedXml, setEcpProtocolSigned] = useState('');
    const { loading: loadingButton, start, stop } = useLoader(false);
    const alert = useAlert(false, 1);
    const { isAdministrator } = useRoles();
    const [watermarkUrl, setWatermarkUrl] = useState(null);
    const [clientPdf, setClientPdf] = useState(null);
    const [clientPdfBeforeSign, setClientPdfBeforeSign] = useState(null);

    const [optionalLogoUrl, setOptionalLogoUrl] = useState(null);
    const [logoUrl, setLogoUrl] = useState(null);
    const [signers2, setSigners2] = useState([]);
    const [splitted, setSplitted] = useState(false);
    const [isSigned, setIsSigned] = useState(false);
    const [isDeclined, setIsDeclined] = useState(false);

    const [stateId, setStateId] = React.useState(null);
    const [accreditationIndicators, setAccreditationIndicators] = useState([]);
    const userChangedLogoSinceOpenRef = useRef(false);

    const dispatch = useDispatch();

    // --- helpers: keep accreditation/logo persisted in DB (protocol.data) ---
    const getUiDataObject = React.useCallback(() => {
        if (!data) return {};
        if (typeof data === "object") return data || {};
        // на всякий случай (если внезапно строка)
        return toUIJson(data) || {};
    }, [data]);

    const getAccreditationInfoFromState = React.useCallback(() => {
        const d = getUiDataObject();
        return d?.accreditationInfo || null;
    }, [getUiDataObject]);

    const persistAccreditationAndLogo = React.useCallback(async () => {
        if (!id) return;
        // не трогаем подписанные протоколы
        if (isSigned) return;

        const accreditationInfo = getAccreditationInfoFromState();
        const request = await protocolsCRUD.get(id);
        const baseData = asJSONSafe(request.data) || {};

        const payload = {
            ...request,
            data: {
                ...baseData,
                logoName: logo || "",
                addOptionalLogo: Boolean(addOptionalLogo),
                accreditationInfo: accreditationInfo || baseData.accreditationInfo || null,
            },
            signers: null,
            pdf: null,
        };
        // Не затираем статус соответствия / тип протокола при автосохранении аттестата/лого
        if (
            complianceStatus === COMPLIANCE_STATUS.COMPLIES ||
            complianceStatus === COMPLIANCE_STATUS.DOES_NOT_COMPLY
        ) {
            payload.complianceStatus = complianceStatus;
            payload.data.complianceStatus = complianceStatus;
            if (complianceStatus === COMPLIANCE_STATUS.DOES_NOT_COMPLY) {
                payload.confirmationStatus = CONFIRMATION_STATUS.PENDING;
                payload.data.confirmationStatus = CONFIRMATION_STATUS.PENDING;
            }
        }
        const persistedTypeId = normalizeProtocolTypeId(typeId);
        if (persistedTypeId != null) {
            payload.typeId = persistedTypeId;
            payload.data.typeId = persistedTypeId;
        }

        await protocolsCRUD.edit(withProtocolParentLinks(payload, protocol));
    }, [
        addOptionalLogo,
        complianceStatus,
        getAccreditationInfoFromState,
        id,
        isSigned,
        logo,
        protocol,
        typeId,
    ]);

    const lastAccreditationAutosaveKeyRef = useRef(null);
    useEffect(() => {
        if (!open) return;
        if (!id) return;
        if (isSigned) return;

        const accreditationInfo = getAccreditationInfoFromState();
        const autosaveKey = JSON.stringify({
            logoName: logo || "",
            addOptionalLogo: Boolean(addOptionalLogo),
            accreditationInfo: accreditationInfo || null,
        });
        if (autosaveKey === lastAccreditationAutosaveKeyRef.current) return;

        const t = setTimeout(async () => {
            try {
                await persistAccreditationAndLogo();
                lastAccreditationAutosaveKeyRef.current = autosaveKey;
            } catch (e) {
                // не блокируем пользователя, просто логируем
                console.warn("Failed to autosave accreditation/logo fields:", e);
            }
        }, 700);
        return () => clearTimeout(t);
    }, [
        open,
        id,
        isSigned,
        logo,
        addOptionalLogo,
        getAccreditationInfoFromState,
        persistAccreditationAndLogo,
    ]);

    useEffect(async () => {
        if (!optionalLogo) {
            setOptionalLogoUrl(null);
            return;
        }

        await fetchAsBase64(optionalLogo, (_) => {            
            svgToPngFromDpi(_, 300, png => {
                setOptionalLogoUrl(png);
            });
        });
    }, [optionalLogo, addOptionalLogo]);

    useEffect(async () => {
        if (!logo) {
            setLogoUrl(null);
            return;
        }

        await fetchAsBase64(logo, (_) => {
            svgToPngFromDpi(_, 300, png => {
                setLogoUrl(png);
            });
        });
    }, [logo]);


    useEffect(() => {
        if (formId === undefined || !protocol) return
        dispatch(getProtocolFormByKey(formId)).then((obj) => {
            const number = obj?.number;
            const theForm = forms[number];
            setSplitted(theForm?.splitted || false);

            setSigners2(Object.fromEntries(['research_specialist', 'lab_director', 'organization_leader'].map((signerTitle, i) => {
                const titleID = ['performer', 'responsible', 'leader'][i]
                
                const employeeID = protocol[titleID]?.id
                if (employeeID == null)
                    return null;

                const isSigned = signers.find(signer => signer.employeeId === employeeID)?.isSigned
                return [signerTitle, isSigned]
            }).filter(_ => _)));
        });
    }, [formId, protocol]);

    useEffect(() => {
        if (!open) {
            return;
        }

        //setEcpProtocolSigned('');
    }, [open]);

    useEffect(() => {
        if (!client)
            return;

        client.onopen = function () {
            setEcpMessage(null);
        }

        client.onclose = function () {
            setEcpMessage("Ошибка соединения с провайдером ЭЦП (NCALayer)");
        }

        client.close = function () {
            setEcpProtocolSigned('')
            setEcpProtocolXml('')
        }

        client.onmessage = function (msg) {
            if (msg.responseObject)
                setEcpProtocolSigned(msg.responseObject || {});

        };

    }, [client])

    useEffect(async () => {
        if (!open || !protocol)
            return;

        await fetchAsBase64(logoWatermark, (_) => {
            setWatermarkUrl(_);
        });
    }, [open, protocol]);

    const emptyState = () => {
        setId(null);
        setNumber('');
        setCreatedAt('');
        setSignedDate(null);
        setFormId('');
        setReferralId('');
        setResultId('');
        setFilialId('');
        setFilialDivisionId('');
        setDepartmentId('');
        setDivisionId('');
        setResponsibleId('');
        setPerformerId('');
        setComplianceStatus(null);
        setConfirmationStatus(null);
        setConfirmationComment('');
        setShowComplianceFields(false);
        setTypeId(null);
        setProtocolTypes([]);
        setOrderType(null);
        setShowProtocolTypeFields(false);
    };

    const handleForm = async (e) => {
    };

    const handleClose = async () => {
        setOpen(false);
        emptyState();
    };
    useEffect(async () => {
        if (!open || !protocol)
            return;

        const {
            id,
            number,
            data,
            createdAt,
            signedDate,
            formId,
            referralId,
            objectReferralId,
            actId,
            resultId,
            filialId,
            filialDivisionId,
            departmentId,
            divisionId,
            responsibleId,
            performerId,
            state,
            stateId,
            signers,
            complianceStatus: protocolComplianceStatus,
            confirmationStatus: protocolConfirmationStatus,
            orderType: protocolOrderType,
            typeId: protocolTypeId,
            type: protocolType,
            TypeId,
            ComplianceStatus,
            ConfirmationStatus,
        } = protocol || { signers: [] };
        setData(data && toUIJson(data))
        setSigned(state?.code === 'Signed')
        setId(id);
        setNumber(number);
        setCreatedAt(createdAt);
        setSignedDate(signedDate);
        setFormId(formId);
        setStateId(stateId);
        setReferralId(referralId);
        setResultId(resultId);
        setFilialId(filialId);
        setFilialDivisionId(filialDivisionId);
        setDepartmentId(departmentId);
        setDivisionId(divisionId);
        setResponsibleId(responsibleId);
        setPerformerId(performerId);
        setSigners(signers)
        const json = toUIJson(data) || {};
        let resolvedOrderType = resolveProtocolOrderType({
            orderType: protocolOrderType,
            OrderType: protocol?.OrderType,
            objectReferralId,
            referralId,
            act: protocol?.act ?? protocol?.Act,
        });
        const initialTypeId = resolveProtocolTypeId(
            {
                typeId: protocolTypeId ?? TypeId ?? json.typeId ?? json.TypeId,
                TypeId,
                type: protocolType,
                complianceStatus: protocolComplianceStatus ?? ComplianceStatus,
                ComplianceStatus,
            },
            { orderType: resolvedOrderType }
        );
        setTypeId(initialTypeId);
        // Бэк/GET иногда не отдаёт compliance на корне — дублируем в data
        // Для платных ComplianceStatus может хранить TypeId — не читаем как соответствие
        const resolvedCompliance = isPaidProtocolOrderType(resolvedOrderType)
            ? null
            : normalizeComplianceStatus(
                protocolComplianceStatus ??
                    ComplianceStatus ??
                    json.complianceStatus ??
                    json.ComplianceStatus
            );
        const resolvedConfirmation = isPaidProtocolOrderType(resolvedOrderType)
            ? null
            : normalizeConfirmationStatus(
                protocolConfirmationStatus ??
                    ConfirmationStatus ??
                    json.confirmationStatus ??
                    json.ConfirmationStatus
            );
        setComplianceStatus(resolvedCompliance);
        setConfirmationStatus(resolvedConfirmation);
        // Сразу показываем поле, если статус уже есть (не ждём async цели отбора)
        setShowComplianceFields(
            Boolean(allowConfirmation) ||
                resolvedCompliance != null ||
                resolvedConfirmation != null
        );
        setShowProtocolTypeFields(
            shouldShowProtocolType({
                orderType: resolvedOrderType,
                stateId,
                typeId: initialTypeId,
            })
        );
        setOrderType(resolvedOrderType);
        // console.log(toUIJson(data))
        setLogo(json["logoName"])
        setAddOptionalLogo(json["addOptionalLogo"]);
        setIsSigned(stateId == protocolStateIds.signed);
        setIsDeclined(stateId == protocolStateIds.declined);

        setClientPdf(null);

        if (open) {
            dispatch(getProtocolTypes({ paging: { take: 1000 } })).then((items) => {
                if (items) setProtocolTypes(items);
            });
        }

        if (resultId) {
            const result = await resultCRUD.get(resultId);
            await setResult(result);
        }

        setProtocolIssueDate(null);

        let resolvedPurpose = null;

        if (signedDate) {
            const d = new Date(signedDate);
            d.setHours(d.getHours() + 5);
            setProtocolIssueDate(d);
        } else if (referralId) {
            const referral = await referralCRUD.get(referralId)
            if (referral && referral.researchEndDateTime != "0001-01-01T00:00:00")
                await setProtocolIssueDate(new Date(referral.researchEndDateTime))
            resolvedOrderType = resolveProtocolOrderType(
                { ...protocol, referralId, orderType: referral?.orderType ?? referral?.OrderType },
                resolvedOrderType
            );
            resolvedPurpose =
                referral?.purposeOfSelection ||
                referral?.PurposeOfSelection ||
                referral?.samplingPurpose ||
                null;
            if (!resolvedPurpose && referral?.purposeOfSelectionId) {
                try {
                    resolvedPurpose = await entityCRUD("purposeOfSelection").get(
                        referral.purposeOfSelectionId
                    );
                } catch {
                    resolvedPurpose = null;
                }
            }
        } else if (objectReferralId) {
            const objectReferral = await anObjectReferralCRUD.get(objectReferralId)
            if (objectReferral && objectReferral.researchEndDateTime != "0001-01-01T00:00:00")
                await setProtocolIssueDate(new Date(objectReferral.researchEndDateTime))
            if (resolvedOrderType == null || !Number.isFinite(resolvedOrderType)) {
                resolvedOrderType = orderTypeIds.government;
            }
            resolvedPurpose =
                objectReferral?.purposeOfSelection ||
                objectReferral?.PurposeOfSelection ||
                null;
            if (!resolvedPurpose && objectReferral?.purposeOfSelectionId) {
                try {
                    resolvedPurpose = await entityCRUD("purposeOfSelection").get(
                        objectReferral.purposeOfSelectionId
                    );
                } catch {
                    resolvedPurpose = null;
                }
            }
        } else if (actId) {
            try {
                const act = await actCRUD.get(actId);
                const actData = asJSONSafe(act?.data) || act?.data || {};
                resolvedOrderType = resolveProtocolOrderType(
                    { ...protocol, actId, act },
                    resolvedOrderType
                );
                resolvedPurpose =
                    act?.purposeOfSelection ||
                    actData?.purposeOfSelection?.value ||
                    actData?.samplingPurpose?.value ||
                    null;
                if (
                    !resolvedPurpose &&
                    (act?.purposeOfSelectionId || actData?.purposeOfSelectionId)
                ) {
                    resolvedPurpose = await entityCRUD("purposeOfSelection").get(
                        act.purposeOfSelectionId || actData.purposeOfSelectionId
                    );
                }
            } catch {
                resolvedPurpose = null;
            }
        }

        if (
            !isPaidProtocolOrderType(resolvedOrderType) &&
            !shouldShowProtocolCompliance({
                orderType: resolvedOrderType,
                purpose: resolvedPurpose,
            })
        ) {
            const linked = await fetchKsekDocumentPurpose({
                actId,
                objectReferralId,
                referralId,
            });
            if (linked?.purpose) {
                resolvedPurpose = linked.purpose;
            }
            if (linked?.orderType) {
                resolvedOrderType = linked.orderType;
            }
        }

        setShowComplianceFields(
            (!isPaidProtocolOrderType(resolvedOrderType) &&
                shouldShowProtocolCompliance({
                    orderType: resolvedOrderType,
                    purpose: resolvedPurpose,
                })) ||
                Boolean(allowConfirmation) ||
                (!isPaidProtocolOrderType(resolvedOrderType) &&
                    (resolvedCompliance != null || resolvedConfirmation != null))
        );

        const finalTypeId = resolveProtocolTypeId(protocol, {
            orderType: resolvedOrderType,
        }) ?? initialTypeId;
        setTypeId(finalTypeId);
        setOrderType(resolvedOrderType);
        setShowProtocolTypeFields(
            shouldShowProtocolType({
                orderType: resolvedOrderType,
                stateId,
                typeId: finalTypeId,
            })
        );

        if (isPaidProtocolOrderType(resolvedOrderType)) {
            setComplianceStatus(null);
            setConfirmationStatus(null);
        }
        // } else if (actId) {
        //     const act = await actCRUD.get(actId)
        //     if (act && act.researchEndDateTime != "0001-01-01T00:00:00")
        //         await setProtocolIssueDate(new Date(act.researchEndDateTime))
        // }



        // if(referralId){
        //     const referral = await referralCRUD.get(referralId)
        //     await setProtocolIssueDate(new Date(.researchEndDateTime))  
        // }

        const employeeId = JSON.parse(window.localStorage.employee).id;
        const canSign = (signers || [])
            .map(_ => _?.employeeId)
            .includes(employeeId);
        setUserCanSignProtocol(canSign);

        const signerIds = signers?.map?.(({ employeeId }) => employeeId);
        setSignersIds(signerIds);

        setEmployee(parseJsonSafe(window.localStorage.employee));
        setFilialDivision(protocol?.filialDivision);
    }, [open, protocol, allowConfirmation]);

    const accrediationsResource = useResourceLinq(accreditationCRUD);
    const accreditationIndicatorsResource = useResourceLinq(accreditationIndicatorCRUD);

    const fillAccreditationFromApiLogo = React.useCallback((value) => {
        if (!value) return;
        const selectedValue = String(value).trim();
        const selectedName = selectedValue.startsWith("/static/media/")
            ? selectedValue
                .substring("/static/media/".length)
                .replace(/\s+black.*$/i, "")
                .replace(/\.svg$/i, "")
            : selectedValue;
        // Код аккредитации: KZ.A.D1.D2, где A — верхнеуровневый буквенный
        // сегмент, D1/D2 — числовые сегменты до 4 знаков. Для старого формата
        // дополнительно допускаем букву в начале последнего сегмента:
        // KZ.T.14.E1213.
        const codeMatch = selectedName.match(/KZ\.[A-ZА-ЯЁ]+\.\d{1,4}\.(?:\d{1,4}|[A-ZА-ЯЁ]\d{1,4})/i);
        const selectedAccreditationCode = codeMatch?.[0]?.toUpperCase() || "";
        const acc = logos?.find((l) => {
            const signBase64 = String(l?.sign?.base64 ?? l?.sign?.Base64 ?? "").trim();
            return signBase64 === selectedValue;
        }) || logos?.find((l) => {
            const name = String(l?.name ?? l?.Name ?? "").trim();
            const certificateNumber = String(l?.certificateNumber ?? l?.CertificateNumber ?? "").trim();
            const accText = `${name} ${certificateNumber}`;
            const accCode = accText.match(/KZ\.[A-ZА-ЯЁ]+\.\d{1,4}\.(?:\d{1,4}|[A-ZА-ЯЁ]\d{1,4})/i)?.[0]?.toUpperCase() || "";

            if (selectedAccreditationCode && accCode) {
                return accreditationCodesMatch(selectedAccreditationCode, accCode);
            }

            return name && selectedName.toLowerCase().includes(name.toLowerCase());
        });
        if (!acc && !selectedAccreditationCode) return;
        const accName = selectedAccreditationCode || acc?.name || acc?.Name || "";
        const indicator = findAccreditationIndicatorByName(accreditationIndicators, accName, acc);
        if (!indicator) return;
        const info = buildAccreditationInfoFromIndicator(indicator);
        if (!info) return;
        setData((prev) => {
            const base = typeof prev === "object" && prev ? prev : {};
            return {
                ...base,
                accreditationInfo: {
                    ...(base.accreditationInfo || {}),
                    ...info,
                },
            };
        });
    }, [logos, accreditationIndicators]);

    useEffect(() => {
        if (open) userChangedLogoSinceOpenRef.current = false;
    }, [open]);

    useEffect(() => {
        if (!open || !userChangedLogoSinceOpenRef.current || !logo) return;
        fillAccreditationFromApiLogo(logo);
    }, [accreditationIndicators, fillAccreditationFromApiLogo, logo, logos, open]);

    useEffect(async () => {
        if (!open || !protocol) return;
        const effectiveFilial = filialId || employee?.filialId || protocol?.filialId;
        if (!isAdministrator() && !effectiveFilial) return;
        // console.log(employee)
        // const logoMappings = filialsMapping
        //     .filter(logosGroup => {
        //         if (Array.isArray(logosGroup.filialId)) {
        //             return logosGroup.filialId.includes(employee.filialId)
        //         } else {
        //             return logosGroup.filialId === employee.filialId
        //         }
        //     })
        //     .filter(logosGroup => {
        //         if (!logosGroup.filialDivisionId) return true
        //         if (Array.isArray(logosGroup.filialDivisionId)) {
        //             return logosGroup.filialDivisionId.includes(employee.filialDivisionId)
        //         } else {
        //             return logosGroup.filialDivisionId === employee.filialDivisionId
        //         }
        //     })
        //     .map(logosGroup => {
        //         let group = logos[logosGroup.filialName]
        //         if (logosGroup.filialDivisionName) group = group[logosGroup.filialDivisionName]
        //         return group
        //     })
        //     .reduce((prev, cur) => prev.concat(cur), [])
        //     .concat(...logos.common);

        const matchFilialId = employee?.filialId ?? filialId ?? protocol?.filialId;
        const matchDivisionId = employee
            ? (employee.filialDivisionId ?? null)
            : (filialDivisionId ?? protocol?.filialDivisionId ?? null);

        const logoMappings = filialsMapping
            .filter(logosGroup => {
                if (isAdministrator())
                    return true;
                if (matchFilialId == null) return false;
                if (Array.isArray(logosGroup.filialId)) {
                    return logosGroup.filialId.includes(matchFilialId)
                } else {
                    return logosGroup.filialId === matchFilialId
                }
            })
            .filter(logosGroup => {
                if (isAdministrator())
                    return true;
                if (!logosGroup.filialDivisionId || matchDivisionId == null) return true;
                if (Array.isArray(logosGroup.filialDivisionId)) {
                    return logosGroup.filialDivisionId.includes(matchDivisionId)
                } else {
                    return logosGroup.filialDivisionId === matchDivisionId
                }
            });
        // console.log(logoMappings)
        let logos = selectMany(logoMappings, _ => _.logo);
        logos = distinct(logos, (a, b) => a == b);

        //debugger;

        const excludedLogos = ["2346", "2332", "2331", "0592", "2216", "2201"];

        logos = logos.filter(_ => {
            for (let i = 0; i < excludedLogos.length; i++) {
                const item = excludedLogos[i];
                if (_.indexOf(item) >= 0) {
                    return false;
                }
            }
            return true;
        });

        //debugger;

        setAvailableLogos(logos);

        let accreditationQuery = page({}, 0, null);

        const accreditationFilialForCache = (filialId || protocol?.filialId) ?? null;

        // Знаки в реестре часто заведены только по филиалу (без РО); фильтр по РО отсекал лишнее — как у индикаторов ниже.
        if (!isAdministrator()) {
            const qFilial = accreditationFilialForCache || employee?.filialId;
            if (qFilial) {
                accreditationQuery = where(accreditationQuery, {
                    filialId: equals(qFilial)
                });
            }
        }

        const accreditationsCacheRequest = isAdministrator()
            ? { scope: "admin" }
            : {
                scope: "filial",
                filialId: accreditationFilialForCache,
            };

        const fetchAccreditationsList = async () => {
            let list = await accrediationsResource.toList(accreditationQuery);
            return list.map(_ =>
                normalizeAccreditationRow({ ..._, sign: asJSONSafe(_.sign) ?? _.sign })
            );
        };
        const shouldUseAccreditationsCache = isAdministrator();

        const accreditationsRaw = shouldUseAccreditationsCache
            ? await getOrCreateIdbOnly(
                PROTOCOL_ACCREDITATIONS_IDB_CACHE_KEY,
                accreditationsCacheRequest,
                fetchAccreditationsList,
                PROTOCOL_ACCREDITATIONS_IDB_TTL_MIN
            )
            : await fetchAccreditationsList();
        const accreditations2 = (accreditationsRaw || []).map(normalizeAccreditationRow);
        console.group('ProtocolDetails accreditations debug');
        console.log('context:', {
            isAdministrator: isAdministrator(),
            employeeFilialId: employee?.filialId,
            employeeFilialDivisionId: employee?.filialDivisionId,
            protocolFilialId: protocol?.filialId,
            protocolFilialDivisionId: protocol?.filialDivisionId,
            matchFilialId,
            matchDivisionId,
            accreditationFilialForCache,
            accreditationCount: accreditations2.length,
        });
        console.table(accreditations2.map((accreditation) => ({
            id: accreditation?.id,
            name: accreditation?.name ?? accreditation?.Name,
            filialId: accreditation?.filialId ?? accreditation?.FilialId,
            filialDivisionId: accreditation?.filialDivisionId ?? accreditation?.FilialDivisionId,
        })));
        const filteredAccreditations = accreditations2.filter((accreditation) => {
            if (isAdministrator()) return true;

            const accreditationFilialId = accreditation?.filialId ?? accreditation?.FilialId;
            if (matchFilialId == null || String(accreditationFilialId) !== String(matchFilialId)) {
                return false;
            }

            const accreditationDivisionId =
                accreditation?.filialDivisionId ?? accreditation?.FilialDivisionId;
            const hasUserDivision =
                matchDivisionId != null && String(matchDivisionId).trim() !== '';

            // Если у пользователя нет районного отделения, показываем все знаки филиала.
            if (!hasUserDivision || accreditationDivisionId == null) return true;

            return String(accreditationDivisionId) === String(matchDivisionId);
        });
        console.log('filtered accreditations:', filteredAccreditations.length, filteredAccreditations);
        console.groupEnd();
        setLogos(filteredAccreditations);

        // Показатели аккредитации часто заведены только по филиалу (без РО); фильтр по РО отсекал записи
        let indicatorQuery = page({}, 0, null);
        if (!isAdministrator()) {
            const indFilial = filialId || employee?.filialId || protocol?.filialId;
            if (indFilial) {
                indicatorQuery = where(indicatorQuery, {
                    filialId: equals(indFilial)
                });
            }
        }
        const indicatorsList = await accreditationIndicatorsResource.toList(indicatorQuery);
        setAccreditationIndicators(indicatorsList || []);
    }, [open, protocol, employee?.filialId, filialId, filialDivisionId]);

    useEffect(() => {
        if (!open || !logo) return;
        const resolved = resolveProtocolLogoName(logo, availableLogos, logos);
        if (resolved !== logo) setLogo(resolved);
    }, [open, logo, availableLogos, logos]);

    const persistComplianceStatus = async (statusOverride) => {
        if (!id) return;
        // Частичная подпись (лаборант) ещё не делает протокол Signed — сохраняем статус всегда,
        // пока state не Signed. isSigned из UI после чужой подписи не должен блокировать.
        if (stateId == protocolStateIds.signed) return;

        const status =
            statusOverride !== undefined ? statusOverride : complianceStatus;
        if (
            status !== COMPLIANCE_STATUS.COMPLIES &&
            status !== COMPLIANCE_STATUS.DOES_NOT_COMPLY
        ) {
            return;
        }

        const request = await protocolsCRUD.get(id);
        const baseData = asJSONSafe(request.data) || {};
        // «Не соответствует» → ждём подтверждения; до confirm в eSen не уходит (бэк).
        const payload = {
            ...request,
            complianceStatus: status,
            data: {
                ...baseData,
                complianceStatus: status,
            },
            signers: null,
            pdf: null,
        };
        if (status === COMPLIANCE_STATUS.DOES_NOT_COMPLY) {
            payload.confirmationStatus = CONFIRMATION_STATUS.PENDING;
            payload.data.confirmationStatus = CONFIRMATION_STATUS.PENDING;
        }
        const persistedTypeId = normalizeProtocolTypeId(typeId);
        if (persistedTypeId != null) {
            payload.typeId = persistedTypeId;
            payload.data.typeId = persistedTypeId;
        }
        await protocolsCRUD.edit(withProtocolParentLinks(payload, protocol));
    };

    const persistProtocolTypeId = async (typeOverride) => {
        if (!id) return;
        if (stateId == protocolStateIds.signed) return;
        if (!isPaidProtocolOrderType(orderType)) return;

        const nextTypeId = normalizeProtocolTypeId(
            typeOverride !== undefined ? typeOverride : typeId
        );
        if (nextTypeId == null) return;

        const request = await protocolsCRUD.get(id);
        const baseData = asJSONSafe(request.data) || {};
        const payload = {
            ...request,
            typeId: nextTypeId,
            // Бэк сохраняет TypeId как ComplianceStatus
            complianceStatus: nextTypeId,
            data: {
                ...baseData,
                typeId: nextTypeId,
            },
            signers: null,
            pdf: null,
        };
        await protocolsCRUD.edit(withProtocolParentLinks(payload, protocol));
    };

    const handleComplianceStatusChange = async (rawValue) => {
        const next =
            rawValue === "" || rawValue == null ? null : Number(rawValue);
        setComplianceStatus(next);
        if (next === COMPLIANCE_STATUS.DOES_NOT_COMPLY) {
            setConfirmationStatus(CONFIRMATION_STATUS.PENDING);
            setShowComplianceFields(true);
        } else if (next === COMPLIANCE_STATUS.COMPLIES) {
            setConfirmationStatus(null);
            setShowComplianceFields(true);
        }
        try {
            if (next === COMPLIANCE_STATUS.COMPLIES ||
                next === COMPLIANCE_STATUS.DOES_NOT_COMPLY) {
                await persistComplianceStatus(next);
            }
        } catch (e) {
            console.warn("[Protocol] не удалось сохранить статус соответствия:", e);
            alert.show(0, "Не удалось сохранить статус соответствия: " + e);
        }
    };

    const handleProtocolTypeChange = async (rawValue) => {
        const next =
            rawValue === "" || rawValue == null ? null : Number(rawValue);
        setTypeId(next);
        setShowProtocolTypeFields(true);
        try {
            if (normalizeProtocolTypeId(next) != null) {
                await persistProtocolTypeId(next);
            }
        } catch (e) {
            console.warn("[Protocol] не удалось сохранить тип протокола:", e);
            alert.show(0, "Не удалось сохранить тип протокола: " + e);
        }
    };

    const signProtocol = async () => {
        // Статус обязателен только для первого подписанта
        if (complianceMissingForFirstSigner) {
            alert.show(0, 'Укажите статус соответствия перед подписанием');
            return;
        }
        if (protocolTypeMissingForFirstSigner) {
            alert.show(0, 'Укажите тип протокола перед подписанием');
            return;
        }

        start()
        const request = {
            id,
            comment: "Подписано",
        };
        if (
            complianceStatus === COMPLIANCE_STATUS.COMPLIES ||
            complianceStatus === COMPLIANCE_STATUS.DOES_NOT_COMPLY
        ) {
            request.complianceStatus = complianceStatus;
            if (complianceStatus === COMPLIANCE_STATUS.DOES_NOT_COMPLY) {
                // До workflow/confirm в ИС СЭН не отправлять
                request.confirmationStatus = CONFIRMATION_STATUS.PENDING;
            }
        }
        const signTypeId = normalizeProtocolTypeId(typeId);
        if (signTypeId != null && isPaidProtocolOrderType(orderType)) {
            request.typeId = signTypeId;
        }

        if (ecpProtocolXml && ecpProtocolSignedXml) {
            request.sign = {
                xml: ecpProtocolXml,
                signedXml: ecpProtocolSignedXml
            }
        }
        
        let date = protocolIssueDate ?? new Date();
        try {
            // чтобы поля аттестата/лого не потерялись — сохраняем их в data перед генерацией PDF
            await persistAccreditationAndLogo();
            await persistComplianceStatus();
            await persistProtocolTypeId();
            await createClientPdf(date);
        } catch (e) {
            alert.show(0, 'Не удалось записать pdf. Проверьте что pdf формируется успешно!:' + e);
        }

        let record = await protocolCRUD.get(id);

        if (!record.pdf) {
            alert.show(0, 'Не удалось записать pdf. Проверьте что pdf формируется успешно!');
            stop();
            return;
        }

        const response = await protocolsCRUD.workflowSignRunProtocol(request);
        const signedDate = response.signedDate;
        date = signedDate ?? protocolIssueDate;
        try {
            // Полный edit после подписи затирает complianceStatus — не вызываем.
            // Если бэк сбросил поле на sign — восстанавливаем явно (+ дубль в data).
            if (
                complianceStatus === COMPLIANCE_STATUS.COMPLIES ||
                complianceStatus === COMPLIANCE_STATUS.DOES_NOT_COMPLY
            ) {
                try {
                    const latest = await protocolsCRUD.get(id);
                    const latestData = asJSONSafe(latest.data) || {};
                    const restorePayload = {
                        ...latest,
                        complianceStatus,
                        data: {
                            ...latestData,
                            complianceStatus,
                        },
                        signers: null,
                        pdf: null,
                    };
                    if (complianceStatus === COMPLIANCE_STATUS.DOES_NOT_COMPLY) {
                        restorePayload.confirmationStatus = CONFIRMATION_STATUS.PENDING;
                        restorePayload.data.confirmationStatus =
                            CONFIRMATION_STATUS.PENDING;
                    }
                    await protocolsCRUD.edit(
                        withProtocolParentLinks(restorePayload, protocol)
                    );
                } catch (restoreErr) {
                    console.warn(
                        "[Protocol] не удалось восстановить complianceStatus после подписи:",
                        restoreErr
                    );
                }
            }
            const restoreTypeId = normalizeProtocolTypeId(typeId);
            if (restoreTypeId != null && isPaidProtocolOrderType(orderType)) {
                try {
                    const latest = await protocolsCRUD.get(id);
                    const latestData = asJSONSafe(latest.data) || {};
                    await protocolsCRUD.edit(
                        withProtocolParentLinks(
                            {
                                ...latest,
                                typeId: restoreTypeId,
                                complianceStatus: restoreTypeId,
                                data: {
                                    ...latestData,
                                    typeId: restoreTypeId,
                                },
                                signers: null,
                                pdf: null,
                            },
                            protocol
                        )
                    );
                } catch (restoreErr) {
                    console.warn(
                        "[Protocol] не удалось восстановить typeId после подписи:",
                        restoreErr
                    );
                }
            }
            await createClientPdf(date);
        } catch (e) {
            alert.show(0, 'Не удалось записать pdf. Проверьте что pdf формируется успешно!:' + e);
        }

        record = await protocolCRUD.get(id);

        if (!record.pdf) {
            alert.show(0, 'Не удалось записать pdf. Проверьте что pdf формируется успешно!');
            stop();
            return;
        }

        console.log('signedDate: ' + signedDate);
        console.log('protocolIssueDate: ' + protocolIssueDate);

        if (signedDate)
            setProtocolIssueDate(signedDate);

        // Signed только когда все подписали; иначе заведующий снова откроет форму с Select
        const fullySigned =
            record?.state?.code === "Signed" ||
            Number(record?.stateId) === protocolStateIds.signed;
        setSigned(Boolean(fullySigned));
        setIsSigned(Boolean(fullySigned));
        if (record?.stateId != null) setStateId(record.stateId);
        if (record?.signers) setSigners(record.signers);

        const recordData = asJSONSafe(record?.data) || {};
        const syncedCompliance = normalizeComplianceStatus(
            record?.complianceStatus ??
                record?.ComplianceStatus ??
                recordData.complianceStatus ??
                complianceStatus
        );
        const syncedConfirmation = normalizeConfirmationStatus(
            record?.confirmationStatus ??
                record?.ConfirmationStatus ??
                recordData.confirmationStatus ??
                (syncedCompliance === COMPLIANCE_STATUS.DOES_NOT_COMPLY
                    ? CONFIRMATION_STATUS.PENDING
                    : confirmationStatus)
        );
        if (syncedCompliance != null) {
            setComplianceStatus(syncedCompliance);
            setShowComplianceFields(true);
        }
        if (syncedConfirmation != null) {
            setConfirmationStatus(syncedConfirmation);
            setShowComplianceFields(true);
        }

        if (syncedCompliance === COMPLIANCE_STATUS.DOES_NOT_COMPLY) {
            alert.show(
                1,
                fullySigned
                    ? 'Протокол подписан. В ИС СЭН (eSen) не отправлен — ожидает подтверждения.'
                    : 'Подпись принята. Статус «Не соответствует» сохранён. Нужны подписи остальных.'
            );
        } else {
            alert.show(1, fullySigned ? 'Протокол подписан!' : 'Подпись принята!');
        }
        setOpen(false)
        reload && reload()
        //setEcpProtocolSigned('');
        stop()
    }

    const handleConfirmProtocol = async () => {
        if (!id) return;
        confirmDialog(
            "Подтверждение протокола",
            "Подтвердить протокол со статусом «Не соответствует»? После подтверждения протокол будет отправлен в ИС СЭН (eSen).",
            async () => {
                start();
                try {
                    await confirmProtocolWorkflow(id, confirmationComment || undefined);
                    alert.show(1, 'Протокол подтверждён и отправлен в ИС СЭН');
                    setOpen(false);
                    reload && reload();
                } catch (e) {
                    alert.show(0, 'Не удалось подтвердить: ' + e);
                } finally {
                    stop();
                }
            }
        );
    };

    const handleRejectConfirmation = async () => {
        if (!id) return;
        confirmDialog(
            "Отклонение подтверждения",
            "Отклонить протокол? В ИС СЭН (eSen) он отправлен не будет.",
            async () => {
                start();
                try {
                    await rejectProtocolConfirmationWorkflow(id, confirmationComment || undefined);
                    alert.show(1, 'Протокол отклонён — в ИС СЭН не отправляется');
                    setOpen(false);
                    reload && reload();
                } catch (e) {
                    alert.show(0, 'Не удалось отклонить: ' + e);
                } finally {
                    stop();
                }
            }
        );
    };

    const generatePdf = async (date, onBase64) => {
        const model = new ProtocolPdfModel();
        const docDefinition = await model.generatePdf(protocol, addOptionalLogo, optionalLogoUrl, logoUrl, data, signers2, date, pageOrientation);

        const pdfDocGenerator = pdfMake.createPdf(docDefinition);
        pdfDocGenerator.getBase64(async (result) => {
            if (onBase64)
                await onBase64(result);
        });
    }

    const createClientPdf = async (date) => {
        start()
        const request = await protocolsCRUD.get(id);
        request.data = asJSONSafe(request.data);
        request.signers = null;

        // подмешиваем актуальные поля аттестата/лого (из формы) в request.data, чтобы ушло в БД вместе с pdf
        const accreditationInfo = getAccreditationInfoFromState();
        request.data = {
            ...(request.data || {}),
            logoName: logo || "",
            addOptionalLogo: Boolean(addOptionalLogo),
            accreditationInfo: accreditationInfo || request.data?.accreditationInfo || null,
        };

        const result = await new Promise(async (resolve, reject) => {
            await generatePdf(date, async _ => {
                if (!_) {
                    console.log("PDF is not generated");
                    alert('Пожалуйста, переформируйте pdf, иначе он не попадет во внешние системы МИС.');
                    stop();
                    reject(new Error("PDF not generated")); 
                    return;
                }
                
                try {
                    request.pdf = _;
                    request.externallyReceived = false;
                    request.updatePdf = true;
                    //await protocolsCRUD.edit(request);
                    await protocolsCRUD.put('pdf', {
                        id: request.id,
                        pdf: request.pdf,
                        externallyReceived: request.externallyReceived
                    });
                    reload && reload();
                    
                    stop();
                    resolve(true);
                } catch (e) {
                    reject(e);
                }
            });   
        });
        
        return result;
    }


    const editorRef = useRef(null);

    const [tabIndex, setTabIndex] = useState(0);
    const authorizedEmployee = useSelector(state => state.employee.authorizedEmployee)

    const lastSigned = React.useMemo(() => {
        return signers?.find(el => el.lastSigned) || null
    }, [signers])

    const hasYourSign = React.useMemo(() => {
        return signers?.find(el => el.userId === authorizedEmployee.userId && el.isSigned) || false
    }, [signers])

    /** Хотя бы одна подпись уже стоит — статус соответствия / тип выбирает только первый подписант. */
    const hasAnySignerSigned = React.useMemo(
        () => Boolean(signers?.some((el) => el.isSigned)),
        [signers]
    );

    const canEditCompliance =
        showComplianceFields && !signed && !hasAnySignerSigned;

    const complianceMissingForFirstSigner =
        canEditCompliance &&
        complianceStatus !== COMPLIANCE_STATUS.COMPLIES &&
        complianceStatus !== COMPLIANCE_STATUS.DOES_NOT_COMPLY;

    const canEditType = canEditProtocolType({
        orderType,
        stateId,
        signed,
        hasAnySignerSigned,
    });

    const protocolTypeMissingForFirstSigner =
        canEditType && normalizeProtocolTypeId(typeId) == null;

    // Для 2-го+ подписанта подтягиваем статус/тип, если GET при открытии их не отдал
    const complianceRefetchDoneRef = useRef(false);
    useEffect(() => {
        if (!open || !id) {
            complianceRefetchDoneRef.current = false;
            return;
        }
        if (!hasAnySignerSigned) return;
        if (complianceStatus != null && typeId != null) return;
        if (complianceRefetchDoneRef.current) return;
        complianceRefetchDoneRef.current = true;

        let cancelled = false;
        (async () => {
            try {
                const record = await protocolCRUD.get(id);
                if (cancelled) return;
                const recordData = asJSONSafe(record?.data) || {};
                const recordOrderType =
                    record?.orderType ?? record?.OrderType ?? orderType;
                if (isPaidProtocolOrderType(recordOrderType)) {
                    const syncedType = resolveProtocolTypeId(record, {
                        orderType: recordOrderType,
                    });
                    if (syncedType != null) {
                        setTypeId(syncedType);
                        setShowProtocolTypeFields(true);
                        setOrderType(Number(recordOrderType));
                    }
                    return;
                }
                const synced = normalizeComplianceStatus(
                    record?.complianceStatus ??
                        record?.ComplianceStatus ??
                        recordData.complianceStatus
                );
                const syncedConf = normalizeConfirmationStatus(
                    record?.confirmationStatus ??
                        record?.ConfirmationStatus ??
                        recordData.confirmationStatus
                );
                if (synced != null) {
                    setComplianceStatus(synced);
                    setShowComplianceFields(true);
                }
                if (syncedConf != null) {
                    setConfirmationStatus(syncedConf);
                    setShowComplianceFields(true);
                }
            } catch (e) {
                console.warn("[Protocol] не удалось догрузить complianceStatus/typeId:", e);
            }
        })();

        return () => {
            cancelled = true;
        };
    }, [open, id, hasAnySignerSigned, complianceStatus, typeId, orderType]);



    const last = React.useMemo(() => {
        if (signed) {
            return signers?.slice(-1)[0] || null
        }
        return null

    }, [signers])

    const textTemplate = (s) => {
        return `<span style="font-size: 14pt; font-family: 'Times New Roman', serif">${s || ""}</span>`;
    }


    const handleGenerateHTML = (numeration = true, signed = false, qrData, dateOfIssue) => {
        const html = editorRef.current.getContent();
        const header = `${textTemplate("№" + number + " " + Intl.DateTimeFormat('ru-RU', {
            day: 'numeric',
            month: 'numeric',
            year: 'numeric'
        }).format(dateOfIssue || new Date()) + " ж. (г.)")}`
        const readHtml = `
                <!DOCTYPE HTML PUBLIC "-//W3C//DTD HTML 4.0 Transitional//EN">
                <html xmlns:v="urn:schemas-microsoft-com:vml"
                      xmlns:o="urn:schemas-microsoft-com:office:office"
                      xmlns:w="urn:schemas-microsoft-com:office:word"
                      xmlns:m="http://schemas.microsoft.com/office/2004/12/omml"
                      xmlns="http://www.w3.org/TR/REC-html40">
                
                <head>
                <style>
                v\:* {behavior:url(#default#VML);}
                o\:* {behavior:url(#default#VML);}
                w\:* {behavior:url(#default#VML);}
                .shape {behavior:url(#default#VML);}
                </style>
                <style>            
                      @bottom-left {
                        content: counter(page) ' of ' counter(pages);
                      }
                @page Section1 {size:595.45pt 841.7pt; margin:0.5in 0.5in 0.5in 0.5in;mso-page-orientation:portrait;mso-header-margin:.5in;mso-footer-margin:.5in;mso-paper-source:0; mso-footer: f1; mso-header: h1; mso-first-header: fh1; mso-first-footer: ff1;}
                        div.Section1 {page:Section1;}
                        @page Section2 {size:841.7pt 595.45pt;mso-page-orientation:landscape;margin:1.25in 1.0in 1.25in 1.0in;mso-header-margin:.5in;mso-footer-margin:.5in;mso-paper-source:0;mso-footer: f1; mso-header: h1; mso-first-header: fh1; mso-first-footer: ff1;}
                        div.Section2 {page:Section2;}
                        div.table-bordered td { border: 1px solid black !important; } 
                         p.headerFooter { margin:0in; text-align: center; }
                </style>
                </head>
                <body>
                <div class=Section1>
                ${html}
                </div>
                ${signed ? `<p style="font-size: 8pt; margin-top: 200px">Осы құжат "Электрондық құжат және электрондық цифрлық қолтаңба туралы " Қазақстан Республикасының 2003 жылғы 7 қаңтардағы N 370-II Заңы 7 бабының 1 тармағына сәйкес қағаз тасығыштағы құжатпен
            бірдей.</p>` : ''}
                ${signed ? `<p style="font-size: 8pt;">Данный документ согласно пункту 1 статьи 7 ЗРК от 7 января 2003 года «Об электронном документе и электронной цифровой подписи» равнозначен документу на бумажном носителе.</p>` : ''}
                ${numeration ? renderPageNumerationAndWatermark(header, watermarkUrl) : ''} 
                ${qrData && signed ? `<img width="122" height="123" src=${qrData}/>` : ''}
                </body>
                </html>
         `

        return readHtml
    }

    const willSelectEcp = (data, last = false) => {        
        let lastData = null;
        if (last) {
            lastData = unescape(encodeURIComponent(data));
        }
        const protocolXML = last ?
            lastData : data;
        setEcpProtocolXml(protocolXML);

        client.signXml('PKCS12', 'SIGNATURE', protocolXML);
    }

    const handleSignEcp = async () => {
        if (lastSigned) {
            const data = await protocolSignerCRUD.get(lastSigned.id)
            if (data?.sign) {
                const jsonData = JSON.parse(data?.sign);
                await willSelectEcp(jsonData?.SignedXml, true)
                return;
            }            
        }
        const xml = js2xml(generateLink(id), { compact: true });
        await willSelectEcp(xml);
    }

    const handleRecreate = async () => {
        protocolsCRUD.workflowRun(id, stateId, protocolStateIds.created).then(() => {
            alert.show(1, 'Протокол пересоздан!');
            setOpen(false)
            reload()
            stop()
        })
    }

    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClosePopover = () => {
        setAnchorEl(null);
    };

    const openPopover = Boolean(anchorEl);
    const idPopover = open ? 'simple-popover' : undefined;

    const handleDeclineProtocol = async () => {
        if (!comment?.trim()) {
            alert.show(0, 'Введите комментарий');
            return;
        }
        try {
            start();
            await $authHost.post('/api/v1/protocol/workflow/decline/run', {
                id,
                comment
            });
            alert.show(1, 'Протокол отклонён!');
            handleClosePopover();
            setOpen(false);
            reload();
        } catch (e) {
            const msg = e?.response?.data?.message
                || e?.response?.data?.title
                || e?.message
                || 'Ошибка отклонения протокола';
            alert.show(0, msg);
        } finally {
            stop();
        }
    }

    const [pageOrientation, setPageOrientation] = useState('auto');


    //console.log(availableLogos);
    //console.log(logos);

    return (
        <div>
            <Modal open={open} onClose={handleClose} aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description">
                {loading ? <CircularProgress /> :
                    <Box sx={style}>
                        <Typography id="modal-modal-title" variant="h6" component="h2">
                            {title}
                        </Typography>
                        <Box component="form" onSubmit={handleForm} sx={{ mt: 1, display: 'flex', flexWrap: 'wrap' }}>
                            <Grid container spacing={2}>   
                                {isDeclined && <Grid item xs={12}> 
                                    <label>Комментарий: {protocol?.comment}</label>
                                </Grid>}                             
                                <Grid item xs={6}>                                    
                                    Номер: {number}
                                </Grid>
                                <Grid item xs={6}>
                                    Создано: {formatDate(createdAt, MOMENT_FORMAT_DATE_DMYHM_DOTS)}                                    
                                    <Button
                                        variant="contained"
                                        disabled={!isDeclined}
                                        sx={{ margin: '0px 10px 0px 0px' }}
                                        onClick={handleRecreate}
                                        style={{float: 'right'}}
                                    >
                                        Пересоздать
                                    </Button>
                                </Grid>
                                <Grid item xs={6}>
                                    Форма: {protocol?.form?.number}
                                </Grid>
                                <Grid item xs={6}>
                                    Направление: {protocol?.referralId}
                                </Grid>
                                <Grid item xs={6}>
                                    Журнал: {result?.number}, ({result?.form?.name || result?.form?.number})
                                </Grid>
                                <Grid item xs={6}>
                                    Филиал: {protocol?.filial?.name}
                                </Grid>
                                <Grid item xs={6}>
                                    Районнное отделение: {filialDivision?.name}
                                </Grid>
                                <Grid item xs={6}>
                                    Лаборатория: {protocol?.department?.name}
                                </Grid>
                                <Grid item xs={6}>
                                    Отдел: {protocol?.division?.name}
                                </Grid>
                                <Grid item xs={6}>
                                    Заведующий лабораторией: {protocol?.responsible?.fullName}
                                </Grid>
                                <Grid item xs={6}>
                                    Исполнитель (лаборант): {protocol?.performer?.fullName}
                                </Grid>
                                <Grid item xs={12}>
                                    <Stack spacing={2}>
                                        <div>
                                            <Typography variant='h6' component='h2'>Экспорт WORD</Typography>
                                        </div>
                                        <div>
                                            <FormControl fullWidth>
                                                <InputLabel id='logo-select'>Выберите логотип для документа</InputLabel>
                                                <Select
                                                    labelId='logo-select'
                                                    id="demo-simple-select"
                                                    value={logo}
                                                    label='Выберете логотип для документа'
                                                    onChange={({ target: { value } }) => {
                                                        userChangedLogoSinceOpenRef.current = true;
                                                        setLogo(value);
                                                        fillAccreditationFromApiLogo(value);
                                                    }}
                                                    disabled={isSigned && logo}
                                                    renderValue={(selected) =>
                                                        selected ? (
                                                            <img
                                                                src={selected}
                                                                alt=""
                                                                style={{ height: 48, maxWidth: "100%", objectFit: "contain" }}
                                                            />
                                                        ) : (
                                                            "Без логотипа"
                                                        )
                                                    }
                                                >
                                                    <MenuItem value=''>
                                                        Без логотипа
                                                    </MenuItem>
                                                    <MenuItem
                                                        disableRipple
                                                        disableGutters
                                                        onClick={(event) => event.stopPropagation()}
                                                    >
                                                        <TextField
                                                            autoFocus
                                                            fullWidth
                                                            size='small'
                                                            label='Поиск знака аккредитации'
                                                            value={logoSearch}
                                                            onChange={(event) => setLogoSearch(event.target.value)}
                                                            onKeyDown={(event) => event.stopPropagation()}
                                                            onClick={(event) => event.stopPropagation()}
                                                        />
                                                    </MenuItem>
                                                    {availableLogos?.includes(logo) && availableLogos
                                                        .filter((logoURL) => {
                                                            const query = logoSearch.trim().toLowerCase();
                                                            return !query || String(logoURL).toLowerCase().includes(query);
                                                        })
                                                        .map(logoURL => (
                                                        <MenuItem value={logoURL} key={logoURL}>
                                                            <img src={logoURL} alt='Логотип филиала'
                                                                style={{ height: 70 }} />
                                                        </MenuItem>
                                                    ))}
                                                    {logos && logos
                                                        .filter((accreditation) => {
                                                            const query = logoSearch.trim().toLowerCase();
                                                            if (!query) return true;

                                                            const searchableText = [
                                                                accreditation?.name,
                                                                accreditation?.Name,
                                                                accreditation?.certificateNumber,
                                                                accreditation?.CertificateNumber,
                                                            ]
                                                                .filter(Boolean)
                                                                .join(' ')
                                                                .toLowerCase();

                                                            return searchableText.includes(query);
                                                        })
                                                        .map((accreditation) => (
                                                            <MenuItem
                                                                value={accreditation?.sign?.base64}
                                                                key={accreditation?.id}
                                                            >
                                                                <img
                                                                    src={accreditation?.sign?.base64}
                                                                    alt='Логотип филиала'
                                                                    style={{ height: 70 }}
                                                                />
                                                            </MenuItem>
                                                        ))}
                                                </Select>
                                            </FormControl>
                                        </div>
                                        {logo && (
                                            <div>
                                                <Typography variant="subtitle2" style={{ marginBottom: 8 }}>
                                                    Данные аттестата аккредитации (для PDF)
                                                </Typography>
                                                <Grid container spacing={2}>
                                                    <Grid item xs={12} md={4}>
                                                        <TextField
                                                            fullWidth
                                                            label="Дата регистрации KZ (как в тексте)"
                                                            value={data?.accreditationInfo?.registeredAtKz || data?.accreditationInfo?.registeredAt || ""}
                                                            onChange={(e) =>
                                                                setData((prev) => {
                                                                    const base = typeof prev === "object" && prev ? prev : {};
                                                                    return {
                                                                        ...base,
                                                                        accreditationInfo: {
                                                                            ...(base.accreditationInfo || {}),
                                                                            registeredAtKz: e.target.value,
                                                                        },
                                                                    };
                                                                })
                                                            }
                                                            disabled={isSigned}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} md={4}>
                                                        <TextField
                                                            fullWidth
                                                            label="№ знака (например KZ.Т.14.Е 1213)"
                                                            value={data?.accreditationInfo?.markNumber || data?.accreditationInfo?.markName || ""}
                                                            onChange={(e) =>
                                                                setData((prev) => {
                                                                    const base = typeof prev === "object" && prev ? prev : {};
                                                                    return {
                                                                        ...base,
                                                                        accreditationInfo: {
                                                                            ...(base.accreditationInfo || {}),
                                                                            markNumber: e.target.value,
                                                                        },
                                                                    };
                                                                })
                                                            }
                                                            disabled={isSigned}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} md={4}>
                                                        <TextField
                                                            fullWidth
                                                            label="Срок действия до KZ (как в тексте)"
                                                            value={data?.accreditationInfo?.validUntilKz || data?.accreditationInfo?.validUntil || ""}
                                                            onChange={(e) =>
                                                                setData((prev) => {
                                                                    const base = typeof prev === "object" && prev ? prev : {};
                                                                    return {
                                                                        ...base,
                                                                        accreditationInfo: {
                                                                            ...(base.accreditationInfo || {}),
                                                                            validUntilKz: e.target.value,
                                                                        },
                                                                    };
                                                                })
                                                            }
                                                            disabled={isSigned}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} md={6}>
                                                        <TextField
                                                            fullWidth
                                                            label="Дата регистрации RU (как в тексте)"
                                                            value={data?.accreditationInfo?.registeredAtRu || data?.accreditationInfo?.registeredAt || ""}
                                                            onChange={(e) =>
                                                                setData((prev) => {
                                                                    const base = typeof prev === "object" && prev ? prev : {};
                                                                    return {
                                                                        ...base,
                                                                        accreditationInfo: {
                                                                            ...(base.accreditationInfo || {}),
                                                                            registeredAtRu: e.target.value,
                                                                        },
                                                                    };
                                                                })
                                                            }
                                                            disabled={isSigned}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} md={6}>
                                                        <TextField
                                                            fullWidth
                                                            label="Срок действия до RU (как в тексте)"
                                                            value={data?.accreditationInfo?.validUntilRu || data?.accreditationInfo?.validUntil || ""}
                                                            onChange={(e) =>
                                                                setData((prev) => {
                                                                    const base = typeof prev === "object" && prev ? prev : {};
                                                                    return {
                                                                        ...base,
                                                                        accreditationInfo: {
                                                                            ...(base.accreditationInfo || {}),
                                                                            validUntilRu: e.target.value,
                                                                        },
                                                                    };
                                                                })
                                                            }
                                                            disabled={isSigned}
                                                        />
                                                    </Grid>
                                                </Grid>
                                            </div>
                                        )}
                                        <div>
                                            <FormGroup>
                                                <FormControlLabel
                                                    control={<Checkbox checked={addOptionalLogo}
                                                        onChange={(_, value) => setAddOptionalLogo(value)} />}
                                                    label='Добавить логотип ilac-MRA'
                                                    // disabled={isSigned && logo}
                                                />
                                            </FormGroup>
                                            <FormControl size="small" sx={{ minWidth: 230 }}>
                                                <InputLabel id="pdf-orientation-label">Ориентация PDF</InputLabel>
                                                <Select
                                                    labelId="pdf-orientation-label"
                                                    value={pageOrientation}
                                                    label="Ориентация PDF"
                                                    onChange={event => setPageOrientation(event.target.value)}
                                                >
                                                    <MenuItem value="auto">Авто (по ширине таблицы)</MenuItem>
                                                    <MenuItem value="portrait">Книжная</MenuItem>
                                                    <MenuItem value="landscape">Альбомная</MenuItem>
                                                </Select>
                                            </FormControl>
                                            
                                                <LocalizationProvider dateAdapter={AdapterDateFns} locale={ruLocale}>
                                                    <DateTimePicker
                                                        renderInput={props => <TextField {...props} />}
                                                        showTodayButton
                                                        label='Дата выдачи протокола'
                                                        value={protocolIssueDate}
                                                        onChange={setProtocolIssueDate} 
                                                        disabled={isSigned && protocolIssueDate}
                                                    />
                                                </LocalizationProvider>
                                            
                                        </div>
                                    </Stack>
                                </Grid>

                                {open && <Grid item xs={12}>
                                    <Box>
                                        {/* <Tabs value={tabIndex} onChange={(event, value) => setTabIndex(value)}>
                                            <Tab label="Word"/>
                                            <Tab label="Pdf"/>                                            
                                        </Tabs> */}
                                        <Box>
                                            {protocol && signersIds && protocolIssueDate && <HtmlGenerator
                                                data={data}
                                                protocol={protocol}
                                                ref={editorRef}
                                                lastSigned={lastSigned}
                                                last={last}
                                                signed={signed}
                                                handleClose={handleClose}
                                                signers={signers}
                                                handleGenerateHTML={handleGenerateHTML}
                                                formID={formId}
                                                filialDivision={filialDivision}
                                                filial={protocol?.filial ?? employeeFilial}
                                                logo={logo}
                                                number={number}
                                                addOptionalLogo={addOptionalLogo}
                                                dateOfIssue={protocolIssueDate}
                                            />}
                                        </Box>
                                        <Box>
                                            {protocol && signersIds && protocolIssueDate && <ProtocolPdf
                                                number={number}
                                                protocolData={data}
                                                formId={formId}
                                                protocolSigners={signers2}
                                                logo={logo}
                                                clientPdf={clientPdf}
                                                setClientPdf={setClientPdf}
                                                date={formatDate(createdAt, MOMENT_FORMAT_DATE_DMYHM_DOTS)}
                                                protocol={protocol}
                                                addOptionalLogo={addOptionalLogo}
                                                optionalLogoUrl={optionalLogoUrl}
                                                logoUrl={logoUrl}
                                                dateOfIssue={protocolIssueDate}
                                                pageOrientation={pageOrientation}
                                            />}
                                        </Box>
                                        {/* 
                                        <ClientPdf number={number}
                                            clientPdf={clientPdf}
                                            setClientPdf={setClientPdf}
                                            date={formatDate(createdAt, MOMENT_FORMAT_DATE_DMYHM_DOTS)}
                                            protocol={protocol}
                                        /> */}
                                    </Box>
                                </Grid>}

                                <Grid item xs={12}>
                                    <Grid container>
                                        <Grid item xs={6} style={{
                                            display: 'flex',
                                            justifyContent: 'center',
                                            flexDirection: 'column'
                                        }}>
                                            <Typography variant='caption'>Подписали:</Typography>
                                            {
                                                ['performer', 'responsible', 'leader'].map((key, i) => (
                                                    protocol?.[key] && <Typography variant='caption'>
                                                        {['Лаборант', 'Заведующий лабораторией', 'Руководитель организацией'][i]}
                                                        ({protocol[key].fullName}):
                                                        {signers.find(signer => signer.employeeId === protocol[key].id)?.isSigned ? 'Да' : 'Нет'}
                                                    </Typography>
                                                ))
                                            }
                                        </Grid>
                                        <Grid item xs={6} style={{
                                            display: 'flex',
                                            alignItems: 'flex-end',
                                            flexDirection: 'column'
                                        }}>
                                            {showProtocolTypeFields && (
                                                <FormControl
                                                    fullWidth
                                                    size="small"
                                                    sx={{ mt: 2, maxWidth: 320 }}
                                                    disabled={!canEditType}
                                                >
                                                    <InputLabel id="protocol-type-label" shrink>
                                                        Тип протокола
                                                    </InputLabel>
                                                    {!canEditType ? (
                                                        <Typography
                                                            variant="body2"
                                                            sx={{
                                                                mt: 2.5,
                                                                px: 1.5,
                                                                py: 1,
                                                                border: "1px solid rgba(0,0,0,0.23)",
                                                                borderRadius: 1,
                                                                minHeight: 40,
                                                                display: "flex",
                                                                alignItems: "center",
                                                                color: typeId == null ? "text.secondary" : "text.primary",
                                                            }}
                                                        >
                                                            {getProtocolTypeLabel(typeId, protocolTypes) ||
                                                                (hasAnySignerSigned
                                                                    ? "Выбран первым подписантом"
                                                                    : "—")}
                                                        </Typography>
                                                    ) : (
                                                        <Select
                                                            labelId="protocol-type-label"
                                                            label="Тип протокола"
                                                            notched
                                                            displayEmpty
                                                            value={normalizeProtocolTypeId(typeId) ?? ""}
                                                            onChange={(e) => {
                                                                handleProtocolTypeChange(e.target.value);
                                                            }}
                                                        >
                                                            {(protocolTypes?.length
                                                                ? protocolTypes
                                                                : [
                                                                    { id: 1, name: "Производственный контроль", code: "1" },
                                                                    { id: 2, name: "Другое", code: "2" },
                                                                ]
                                                            ).map((opt) => (
                                                                <MenuItem key={opt.id} value={opt.id}>
                                                                    {opt.name}
                                                                    {opt.code ? ` (${opt.code})` : ""}
                                                                </MenuItem>
                                                            ))}
                                                        </Select>
                                                    )}
                                                    {canEditType && (
                                                        <FormHelperText>
                                                            {getProtocolTypeHelperText(typeId)}
                                                        </FormHelperText>
                                                    )}
                                                    {hasAnySignerSigned && !canEditType && (
                                                        <FormHelperText>
                                                            Тип задаёт первый подписант; изменение недоступно
                                                        </FormHelperText>
                                                    )}
                                                </FormControl>
                                            )}
                                            {showComplianceFields && (
                                                <>
                                            <FormControl
                                                fullWidth
                                                size="small"
                                                sx={{ mt: 2, maxWidth: 320 }}
                                                disabled={!canEditCompliance}
                                            >
                                                <InputLabel id="compliance-status-label" shrink>
                                                    Статус соответствия
                                                </InputLabel>
                                                {!canEditCompliance ? (
                                                    <Typography
                                                        variant="body2"
                                                        sx={{
                                                            mt: 2.5,
                                                            px: 1.5,
                                                            py: 1,
                                                            border: "1px solid rgba(0,0,0,0.23)",
                                                            borderRadius: 1,
                                                            minHeight: 40,
                                                            display: "flex",
                                                            alignItems: "center",
                                                            color: complianceStatus == null ? "text.secondary" : "text.primary",
                                                        }}
                                                    >
                                                        {getComplianceStatusLabel(complianceStatus) ||
                                                            (hasAnySignerSigned
                                                                ? "Выбран первым подписантом"
                                                                : "—")}
                                                    </Typography>
                                                ) : (
                                                <Select
                                                    labelId="compliance-status-label"
                                                    label="Статус соответствия"
                                                    notched
                                                    displayEmpty
                                                    value={
                                                        complianceStatus === COMPLIANCE_STATUS.COMPLIES ||
                                                        complianceStatus === COMPLIANCE_STATUS.DOES_NOT_COMPLY
                                                            ? complianceStatus
                                                            : ""
                                                    }
                                                    onChange={(e) => {
                                                        handleComplianceStatusChange(e.target.value);
                                                    }}
                                                >
                                                    {COMPLIANCE_STATUS_OPTIONS.map((opt) => (
                                                        <MenuItem key={opt.id} value={opt.id}>{opt.name}</MenuItem>
                                                    ))}
                                                </Select>
                                                )}
                                                {canEditCompliance && (
                                                    <FormHelperText>
                                                        {complianceStatus === COMPLIANCE_STATUS.DOES_NOT_COMPLY
                                                            ? "До подтверждения в ИС СЭН (eSen) не отправляется"
                                                            : "Обязательно перед подписанием (выбирает первый подписант)"}
                                                    </FormHelperText>
                                                )}
                                                {hasAnySignerSigned && !canEditCompliance && (
                                                    <FormHelperText>
                                                        Статус задаёт первый подписант; изменение недоступно
                                                    </FormHelperText>
                                                )}
                                            </FormControl>
                                            {signed && (
                                                <Typography variant="caption" sx={{ mt: 1 }}>
                                                    {complianceStatus === COMPLIANCE_STATUS.COMPLIES
                                                        ? "Подтверждение не требуется"
                                                        : confirmationStatus != null
                                                            ? `Подтверждение: ${getConfirmationStatusLabel(confirmationStatus)}`
                                                            : null}
                                                </Typography>
                                            )}
                                            {allowConfirmation &&
                                                signed &&
                                                complianceStatus === COMPLIANCE_STATUS.DOES_NOT_COMPLY &&
                                                confirmationStatus === CONFIRMATION_STATUS.PENDING && (
                                                <Stack direction="column" spacing={1} sx={{ mt: 2, width: '100%', maxWidth: 320 }}>
                                                    <TextField
                                                        size="small"
                                                        multiline
                                                        label="Комментарий к решению"
                                                        value={confirmationComment}
                                                        onChange={(e) => setConfirmationComment(e.target.value)}
                                                        fullWidth
                                                    />
                                                    <Stack direction="row" spacing={1}>
                                                        <LoadingButton
                                                            loading={loadingButton}
                                                            variant="contained"
                                                            color="success"
                                                            onClick={handleConfirmProtocol}
                                                        >
                                                            Подтвердить
                                                        </LoadingButton>
                                                        <LoadingButton
                                                            loading={loadingButton}
                                                            variant="contained"
                                                            color="error"
                                                            onClick={handleRejectConfirmation}
                                                        >
                                                            Отклонить
                                                        </LoadingButton>
                                                    </Stack>
                                                </Stack>
                                            )}
                                                </>
                                            )}
                                            <Stack direction="row" spacing={2} sx={{ mt: 3, mb: 2 }} alignItems="center">
                                                <LoadingButton loading={loadingButton} type="button"
                                                    disabled={
                                                        signed ||
                                                        hasYourSign ||
                                                        !userCanSignProtocol ||
                                                        complianceMissingForFirstSigner ||
                                                        protocolTypeMissingForFirstSigner ||
                                                        (!Object.keys(ecpProtocolXml)?.length ||
                                                        !Object.keys(ecpProtocolSignedXml)?.length)
                                                    }
                                                    variant="contained"
                                                    onClick={signProtocol}>
                                                    Подписать
                                                </LoadingButton>
                                                <LoadingButton loading={loadingButton} type="button" color="error"
                                                    disabled={signed || !userCanSignProtocol || hasYourSign}
                                                    variant="contained"
                                                    onClick={handleClick}>
                                                    Не согласен
                                                </LoadingButton>
                                                {isAdministrator() &&
                                                    <LoadingButton loading={loadingButton} type="button"

                                                        variant="contained"
                                                        onClick={async () => {
                                                            await createClientPdf(protocolIssueDate);
                                                        }}>
                                                        Сформировать
                                                    </LoadingButton>
                                                }
                                                <Popover
                                                    id={idPopover}
                                                    open={openPopover}
                                                    anchorEl={anchorEl}
                                                    onClose={handleClosePopover}
                                                    anchorOrigin={{
                                                        vertical: 'center',
                                                        horizontal: 'center',
                                                    }}
                                                    transformOrigin={{
                                                        vertical: 'center',
                                                        horizontal: 'center',
                                                    }}
                                                >
                                                    <Stack direction="column" spacing={2} sx={{ padding: 3, width: '350px' }}>
                                                        <TextField
                                                            multiline
                                                            label={"Комментарий"}
                                                            onChange={e => setComment(e.target.value)}
                                                            fullWidth
                                                            value={comment}
                                                        />
                                                        <Button type="button" onClick={handleDeclineProtocol} fullWidth variant="contained" sx={{ mt: 3 }}>
                                                            {'Подтвердить'}
                                                        </Button>
                                                    </Stack>
                                                </Popover>
                                            </Stack>
                                            <div>
                                                <Button
                                                    variant="contained"
                                                    disabled={signed || !userCanSignProtocol || hasYourSign}
                                                    sx={{ margin: '10px 0 10px 0px' }}
                                                    onClick={handleSignEcp}
                                                >
                                                    Выбрать ЭЦП
                                                </Button>
                                            </div>
                                            {(signed || !userCanSignProtocol) && <Typography variant='caption' style={{
                                                maxWidth: 200,
                                                color: '#515151',
                                                textAlign: 'right'
                                            }}>
                                                {signed
                                                    ? 'Протокол уже подписан'
                                                    : !userCanSignProtocol
                                                    && 'Вы не можете подписать протокол, недостаточно прав'
                                                }
                                            </Typography>}
                                        </Grid>
                                    </Grid>
                                </Grid>
                                {action !== 'details' &&
                                    <Grid item xs={6}>
                                        <Button type="submit" fullWidth variant="contained" sx={{ mt: 3, mb: 2 }}>
                                            {'Сохранить'}
                                        </Button>
                                    </Grid>
                                }
                            </Grid>
                        </Box>
                    </Box>
                }
            </Modal>
            {alert.render()}
        </div>
    )
}
